type SupabaseLikeError = {
  code?: string
  message?: string
  details?: string
  hint?: string
}

export const BACKEND_UPDATE_FILE = 'supabase/ATUALIZAR_V4_1.sql'

export function isMissingRpc(error: unknown) {
  const value = error as SupabaseLikeError | null
  const text = `${value?.code || ''} ${value?.message || ''} ${value?.details || ''}`.toLowerCase()
  return value?.code === 'PGRST202' || value?.code === '42883' || text.includes('could not find the function') || text.includes('does not exist') && text.includes('function')
}

export function isMissingSchema(error: unknown) {
  const value = error as SupabaseLikeError | null
  const text = `${value?.code || ''} ${value?.message || ''} ${value?.details || ''}`.toLowerCase()
  return ['42P01', '42703', 'PGRST200', 'PGRST204'].includes(value?.code || '') ||
    text.includes('schema cache') || text.includes('relation') && text.includes('does not exist') || text.includes('column') && text.includes('does not exist')
}

export function friendlyDataError(error: unknown, action = 'concluir esta ação') {
  const value = error as SupabaseLikeError | null
  const code = value?.code || ''
  const text = `${value?.message || ''} ${value?.details || ''} ${value?.hint || ''}`.toLowerCase()

  if (isMissingSchema(error) || isMissingRpc(error)) {
    return `O banco do LIVROOM precisa da atualização V4.1. Execute ${BACKEND_UPDATE_FILE} no Supabase e tente novamente.`
  }
  if (code === '42501' || code === 'PGRST301' || text.includes('row-level security') || text.includes('permission denied')) {
    return `Sua conta não tem permissão para ${action}. Atualize a página ou confirme seu papel no projeto/clube.`
  }
  if (text.includes('club member limit reached')) return 'O clube atingiu o limite de membros.'
  if (text.includes('publishing permission required')) return 'Apenas responsáveis com permissão de publicação podem fazer isso.'
  if (text.includes('club project permission required') || text.includes('project edit permission required')) return 'Seu papel atual não permite editar este projeto de clube.'
  if (text.includes('club manager permission required') || text.includes('reading manager permission required')) return 'Somente gerentes do clube podem concluir esta ação.'
  if (text.includes('accepted friendship required')) return 'Essa leitura só pode ser criada entre amizades aceitas.'
  if (text.includes('already friends')) return 'Vocês já são amigos no LIVROOM.'
  if (text.includes('invitation unavailable')) return 'Este convite expirou ou já foi respondido. Atualize a página.'
  if (text.includes('join request unavailable')) return 'Este pedido já foi respondido. Atualize a lista.'
  if (text.includes('invalid title') || text.includes('invalid club name') || text.includes('invalid club description') || text.includes('invalid target page')) return 'Revise os campos: há um valor vazio, muito longo ou fora do limite permitido.'
  if (text.includes('authentication required')) return 'Sua sessão expirou. Entre novamente para continuar.'
  if (code === '23505' || text.includes('duplicate key')) return 'Este registro já existe. Atualize a página antes de tentar novamente.'
  if (code === '23503' || text.includes('foreign key')) return 'Um item relacionado não existe mais. Atualize a página e tente novamente.'
  if (code === '23514' || code === '23502' || text.includes('check constraint') || text.includes('not-null')) return 'Há um dado inválido ou incompleto. Revise os campos destacados e tente novamente.'
  if (text.includes('failed to fetch') || text.includes('network') || text.includes('load failed')) return 'Sem conexão com o servidor. Confira a internet e tente novamente.'
  return `Não foi possível ${action} agora. Tente novamente em instantes.`
}
